import { AutocompleteInput } from "react-admin";

const CustomAutoCompleteInput = (props: any) => {
    return (
        <AutocompleteInput {...props} sx={{ width: '25%' }} />
    )
}
export default CustomAutoCompleteInput;